import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import { fetchUserInfoAction } from '../../../store/apiActions/fetchUserInfoAction';
import { bonusPromotionsActions } from '../../../store/slices/bonusPromotions/slice';
import { chipActions } from '../../../store/slices/chips/slice';
import type { ChipValueType } from '../../../store/slices/chips/types';
import { ChipSelectionOrigin, ChipTypes } from '../../../store/slices/chips/types';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

export class CoreStartDealingGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.StartDealing;
  public dealingStatus: string = GameStatus.Dealing;

  private lastDispatchedChip: ChipValueType | null = null;
  protected dealingStatusDelay = 2_000;

  process(_message: GameCommunicationMessageType): void {
    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.StartDealing);
    const state = this.store.getState();
    const session = state.config.session;
    const JSESSIONID = session?.JSESSIONID;
    const baseUrl = session?.metaServer;
    const isEligibleCampaign = !!state.bonusPromotions.eligibleBonusCampaign;
    const freeChipPlaced = state.bets.placedBetType === ChipTypes.FreeChip;
    if (JSESSIONID && baseUrl) {
      this.store.dispatch(fetchUserInfoAction({ JSESSIONID, baseUrl, force: true, essential: true }));
      if (isEligibleCampaign && freeChipPlaced) {
        this.store.dispatch(bonusPromotionsActions.setRefetchCampaign(true));
      }
    }

    this.saveLastChip();
    this.setDealingStatus();
  }

  protected saveLastChip(): void {
    const selectedChip = this.store.getState().chips.selectedChip;

    // Save initially selected chip on server after betting phase is over.
    if (!this.lastDispatchedChip && selectedChip && selectedChip.selectedBy === ChipSelectionOrigin.System) {
      this.store.dispatch(chipActions.setAndSyncSelectedChip(selectedChip));
      this.lastDispatchedChip = selectedChip;
    }

    // Save system selected chip on server after betting phase is over.
    if (this.isNotLastDispatchedChip(selectedChip, this.lastDispatchedChip)) {
      this.store.dispatch(chipActions.setAndSyncSelectedChip(selectedChip!));
      this.lastDispatchedChip = selectedChip;
    }
  }

  protected isNotLastDispatchedChip(
    selectedChip: ChipValueType | null,
    lastDispatchedChip: ChipValueType | null
  ): boolean {
    return Boolean(
      lastDispatchedChip &&
        selectedChip?.selectedBy === ChipSelectionOrigin.System &&
        selectedChip.weight !== lastDispatchedChip?.weight &&
        selectedChip.type !== lastDispatchedChip?.type
    );
  }

  protected setDealingStatus(): void {
    const totalBet = this.store.getState().bets.totalBet;
    if (totalBet) {
      setTimeout(() => {
        this.store.dispatch(gameStateActions.setCurrentGameStatus(this.dealingStatus));
      }, this.dealingStatusDelay);
    } else {
      this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.WaitForNextGame));
    }
  }
}
